module.exports = __webpack_public_path__ + "static/llama-bg-01-mobile-aef52dd8709c33d85fb6c55d2ecdb961.png";